import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import KnowledgeHero from "./components/KnowledgeHero";
import ArticleList from "./components/ArticleList";

export default function KnowledgePage() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <KnowledgeHero />
      <ArticleList />
      <SiteFooter />
    </main>
  );
}
